import React, { useState, useRef, useEffect, ReactNode } from "react";
import { ROUTES } from "../../../../constants/routes";

const ExpandableParagraph = ({
  text,
  postId,
}: {
  text: ReactNode;
  postId?: string;
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isClamped, setIsClamped] = useState(false);
  const paragraphRef = useRef<HTMLDivElement>(null);

  const toggleExpansion = () => setIsExpanded(!isExpanded);

  useEffect(() => {
    const element = paragraphRef.current;
    if (element) {
      setIsClamped(element.scrollHeight > element.clientHeight);
    }
  }, [text]);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!postId) return;

    const target = event.target as HTMLElement;
    const postUrl = `${window.location.origin}${ROUTES.ACTIVITY.replace(":activity_id", postId)}`;

    if (target.tagName !== "A" && window.location.href !== postUrl) {
      window.location.href = postUrl;
    }
  };

  const renderParagraph = () => (
    <div
      ref={paragraphRef}
      className={`text-primary-900 relative ${postId ? "cursor-pointer" : ""} ${!isExpanded ? "line-clamp-2" : ""}`}
      style={{
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        whiteSpace: "pre-line",
      }}
      onClick={handleClick}
    >
      {text}
    </div>
  );

  return (
    <div>
      {renderParagraph()}

      {isClamped && !isExpanded && (
        <button
          onClick={toggleExpansion}
          className="text-primary-500 text-sm hover:underline mt-2"
        >
          Read more
        </button>
      )}
      {isExpanded && (
        <button
          onClick={toggleExpansion}
          className="text-primary-500 text-sm hover:underline mt-2"
        >
          Show Less
        </button>
      )}
    </div>
  );
};

export default ExpandableParagraph;
